<template>
  <div>
    <div class="container mb-5">
      <div class="row justify-content-center">
        <h2 class="text-center mb-3"><br />¿QUIÉNES SOMOS? <br /></h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-politics">
          DESARROLLO Y CONSULTORÍA TECNOLÓGICA PARA SOLUCIONES INTEGRALES FYF,
          también conocido como FYF SOLUCIONES o ALL SOLUTIONS, con domicilio en
          CALLE ANDADOR AUSTRIA NÚMERO EXTERIOR 6 NÚMERO INTERIOR PISO 1 ENTRE
          CALLE DINAMARCA Y CALLE ALEMANIA COLONIA CENTRO URBANO LOCALIDAD
          CUAUTITLÁN IZCALLI MUNICIPIO CUAUTITLÁN IZCALLI ENTIDAD FEDERATIVA
          MÉXICO, y portal de internet administracion@fyf.mx, es el responsable
          del uso y protección de sus datos personales, y al respecto le
          informamos lo siguiente: <br />
        </h4>
      </div>
      <div class="row justify-content-center">
        <h2 class="text-center mb-3">
          <br />¿PARA QUÉ FINES UTILIZAREMOS SUS DATOS PERSONALES? <br />
        </h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-politics">
          De manera adicional, utilizaremos su información personal para las
          siguientes finalidades secundarias que no son necesarias para el
          servicio solicitado, pero que nos permiten y facilitan brindarle una
          mejor atención: <br /><br />
          ● Comercial. <br /><br />
          En caso de que no desee que sus datos personales sean tratados para
          estos fines secundarios, desde este momento usted nos puede comunicar
          lo anterior a través del siguiente mecanismo: <br /><br />
          ● Solo sera usado para base de datos comerciales. <br /><br />
          La negativa para el uso de sus datos personales para estas finalidades
          no podrá ser un motivo para que le neguemos los servicios y productos
          que solicita o contrata con nosotros. <br />
        </h4>
      </div>
      <div class="row justify-content-center">
        <h2 class="text-center mb-3">
          <br />¿DÓNDE PUEDO CONSULTAR EL AVISO DE PRIVACIDAD INTEGRAL? <br />
        </h2>
      </div>
      <div class="row justify-content-center">
        <h4 class="text-politics">
          Para conocer mayor información sobre los términos y condiciones en que
          serán tratados sus datos personales, como los terceros con quienes
          compartimos su información personal y la forma en que podrá ejercer
          sus derechos ARCO, puede consultar el aviso de privacidad integral en
          operación personalizada.
        </h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AvisoDePrivacidad"
};
</script>

<style scoped>
.title {
  font-size: 20px;
  color: blue;
  margin-bottom: 10px;
}

.content {
  font-size: 16px;
  color: black;
  margin-bottom: 20px;
}
.text-politics {
  text-align: justify;
}
</style>
